<!--  -->
<template>
  <ul class="skeketon">
    <li class="skeketon-item"  v-for="i in 3" :key="i">
      <div class="skeketon-item-top">
        <span class="w178 h12"></span>
        <span class="w64 h12"></span>
      </div>
      <div class="skeketon-item-center">
        <div class="skeketon-item-center-left">
          <span></span>
          <span></span>
        </div>
        <div class="skeketon-item-center-right"></div>
      </div>
      <div class="skeketon-item-bottom">
        <div class="skeketon-item-bottom-right w160 mb10"></div>
        <div class="skeketon-item-bottom-right w80 mt20"></div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  components: {},

  data () {
    return {
    }
  },

  computed: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
.skeketon{
  @include skeletonBlink();
  &-item{
    width: 100%;
    height: 174px;
    padding: 10px;
    background: var(--APP_skeleton_background_color);
    box-sizing: border-box;
    margin-bottom: 8px;
    &-top{
      display: inline-flex;
      height: 12px;
      width: 100%;
      justify-content: space-between;
      padding-bottom: 12px;
      >span{
        display: inline-block;
        background: var(--APP_skeleton_color);
      }
    }
    &-center{
      width: 100%;
      height: 60px;
      padding: 12px 0;
      overflow: hidden;
      &-left{
        height: 64px;
        float: left;
        >span{
          display: inline-block;
          height: 60px;
          width: 60px;
          margin-right: 25px;
          background:  var(--APP_skeleton_color);
        }
      }
      &-right{
        height: 60px;
        width: 60px;
        float: right;
        background:  var(--APP_skeleton_color);
      }
    }
    &-bottom{
      width: 100%;
      height: 53px;
      margin-top: 10px;
      position: relative;
      &-right{
        height: 12px;
        background: var(--APP_skeleton_color);
        position: absolute;
        right: 0;
      }
    }
  }
}

</style>
